<template>
  <div class="append-box">
    <v-mask
      style="background: ragb(0, 0, 0, 0.6)"
      @touchmove="gtouchmove"
      @click="handleClose"
    ></v-mask>
    <div class="dialog-notice-box">
      <div
        v-bind:class="{
          'animated baisonFadeInDown': true,
          'ani-dialog-notice-box': theme != 'newYear2020',
          'ani-dialog-notice-box-newyear2020': theme == 'newYear2020',
          baisonFadeInUp: fadeOut,
        }"
      >
        <div
          class="title-bg"
          v-show="theme == 'default' || theme == 'newYear2020'"
        ></div>
        <img
          class="title-bg2"
          src="@/assets/img/act-notice/new-year-2020/tu1.png"
          v-show="theme == 'newYear2020'"
        />
        <img
          class="deng-img"
          src="@/assets/img/act-notice/new-year-2020/deng.png"
          v-show="theme == 'newYear2020'"
        />
        <!-- <img
          class="img-2020"
          src="@/assets/img/act-notice/new-year-2020/2020.png"
          v-show="theme=='newYear2020'"
        /> -->
        <img
          class="content-bg"
          src="@/assets/img/act-notice/new-year-2020/dizi2.png"
          v-show="theme == 'newYear2020'"
        />
        <img
          src="@/assets/img/act-notice/new-year/_01.png"
          class="new-year-img-1"
          ondragstart="return false;"
          v-show="theme == 'newYear'"
        />
        <img
          src="@/assets/img/act-notice/new-year/_04.png"
          class="new-year-img-2"
          ondragstart="return false;"
          v-show="theme == 'newYear'"
        />
        <img
          src="@/assets/img/act-notice/new-year/_04.png"
          class="new-year-img-3"
          ondragstart="return false;"
          v-show="theme == 'newYear'"
        />
        <img
          src="@/assets/img/act-notice/new-year/_02.png"
          class="new-year-img-4"
          ondragstart="return false;"
          v-show="theme == 'newYear'"
        />
        <img
          src="@/assets/img/act-notice/new-year/_03.png"
          class="new-year-img-5"
          ondragstart="return false;"
          v-show="theme == 'newYear'"
        />
        <div class="tag-list">
          <div
            v-bind:class="{
              'tag-item tag-item-act': true,
              selected: tabIndex == 0,
            }"
            @click="handleChangeTab(0)"
            v-clickMusic
          >
            Hot Events
          </div>
          <div
            v-bind:class="{
              'tag-item tag-item-notice': true,
              selected: tabIndex == 1,
            }"
            @click="handleChangeTab(1)"
            v-clickMusic
          >
            Game Notice
          </div>
        </div>
        <div class="tag-menu-box" ref="tagMenuBox">
          <ul class="tag-menu-list">
            <li
              v-for="(item, i) in tabMenuData"
              v-bind:class="{
                'tag-menu-item': true,
                notice: tabIndex == 1,
                selected: item.is_default == 1,
              }"
              v-bind:key="i"
              @click="handleChangeTagMenu(item)"
              v-clickMusic
            >
              <div class="item-content">{{ item.title | filterTitle }}</div>
              <span class="innerDiv-fix"><!-- 此标签不能换行 --></span>
            </li>
          </ul>
        </div>
        <div class="content-wrapper" ref="contentWrapper">
          <div class="content" v-if="content.pic_url">
            <img
              :src="content.pic_url"
              @click="handleJump(content)"
              v-clickMusic
            />
          </div>
          <div
            class="content"
            @click="handleTextJump($event, content)"
            v-clickMusic
            v-html="content.content"
            v-else
          ></div>
        </div>
        <btnClose
          v-bind:class="{
            'close-pop-message': true,
            'close-pop-message-new-year-2020': theme == 'newYear2020',
          }"
          v-clickMusic
          @close="handleClose"
        ></btnClose>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import BScroll from "@better-scroll/core";
import btnClose from "@/components/btnClose.vue";
import { openUrl } from "@/utils";
import store from "@/store/index";
export default {
  name: "dialogNotice",
  components: {
    "v-mask": vmask,
    btnClose,
  },
  data() {
    return {
      userKey: "",
      gameID: "",
      theme: store.state.app.theme,
      tabIndex: -1,
      fadeOut: false,
      tabMenuIndex: 1,
      data: [],
      tabMenuData: [],
      content: {},
    };
  },
  mounted() {
    const scrollMenu = new BScroll(this.$refs.tagMenuBox, {
      click: true,
    });
    const scrollContent = new BScroll(this.$refs.contentWrapper, {
      click: true,
    });
    // this.data = [
    //   {
    //     is_default: 1,
    //     type: "2",
    //     child: [
    //       {
    //         type: "2",
    //         title: "Happy New Year",
    //         content: "123123321312312",
    //         is_default: 1,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "2",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //     ],
    //   },
    //   {
    //     is_default: 0,
    //     type: "1",
    //     child: [
    //       {
    //         type: "2",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "",
    //         is_default: 1,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "2",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //     ],
    //   },
    // ];
    this.initData();
    this.$nextTick(() => {
      scrollMenu.refresh();
      scrollContent.refresh();
    });
  },
  filters: {
    filterTitle: function (value) {
      // if (!value) return "";
      // if (String(value).length > 4) {
      //   return String(value).substr(0, 4);
      // } else {
      //   return value;
      // }
      return value;
    },
  },
  watch: {
    tabIndex(val) {
      this.renderDataByIndex(val);
    },
    tabMenuData() {
      this.changeContent();
    },
  },
  methods: {
    initData() {
      const actData = this.getActData();
      this.tabIndex = actData.is_default == 1 ? 0 : 1;
    },
    renderDataByIndex(index) {
      const actData = this.getActData(),
        noticeData = this.getNoticeData();
      if (index == 0) {
        this.tabMenuData = this.supplementaryData(actData.child);
      } else {
        this.tabMenuData = this.supplementaryData(noticeData.child);
      }
    },
    supplementaryData(arr) {
      if (arr.length > 0) {
        if (arr.findIndex((child) => child.is_default == 1) == -1) {
          arr[0].is_default = 1;
        }
        return arr;
      } else {
        return [];
      }
    },
    getActData() {
      return this.getDatByType(2);
    },
    getNoticeData() {
      return this.getDatByType(1);
    },
    getDatByType(type) {
      let data = {
        child: [],
      };
      for (let i = 0; i < this.data.length; i++) {
        if (parseInt(this.data[i].type) == type) {
          data = this.data[i];
          break;
        }
      }
      return data;
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
      this.$newYearScroll(this.userKey, this.gameID);
    },
    handleClose() {
      this.fadeOut = true;
      setTimeout(() => {
        this.remove();
        this.fadeOut = false;
        window.__dialogNotice = null;
      }, 300);
    },
    handleChangeTab(index) {
      this.tabIndex = index;
    },
    handleChangeTagMenu(item) {
      const tempTabMenuData = this.tabMenuData;
      tempTabMenuData[
        tempTabMenuData.findIndex((child) => child.is_default == 1)
      ].is_default = 0;
      tempTabMenuData[
        tempTabMenuData.findIndex((child) => child == item)
      ].is_default = 1;
      this.$nextTick(() => {
        this.changeContent();
      });
    },
    changeContent() {
      let menuData = this.tabMenuData,
        tempContent = {
          content: "",
        };
      if (menuData && menuData.length > 0) {
        tempContent =
          menuData[menuData.findIndex((child) => child.is_default == 1)];
      }
      if (!tempContent.pic_url) {
        tempContent.content = tempContent.content.replace(
          /<link>(.+)<\/link>/g,
          "<span class='span-link'>$1</span>"
        );
        //文字公告，需要过滤链接
      }
      this.content = tempContent;
    },
    handleJump(content) {
      if (content.jump_url) {
        const url = String(content.jump_url);
        let params;
        if (url.indexOf("?") > -1) {
          params = "&identity=";
        } else {
          params = "?identity=";
        }
        let identity = store.state.app.appInfo.identity;
        openUrl(`${content.jump_url}${params}${identity}`);
      }
    },
    handleTextJump(event, content) {
      if (event.target.nodeName == "SPAN") {
        this.handleJump(content);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 88889;
  .dialog-notice-box {
    font-family: Microsoft YaHei;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    height: 2.68rem;
    width: 4.76rem;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    .ani-dialog-notice-box {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/act-notice/HD_tc_bg.png) no-repeat;
      background-size: cover;
      font-size: 0.12rem;
      -webkit-animation-duration: 0.3s;
      animation-duration: 0.3s;
      position: relative;
    }
    .ani-dialog-notice-box-newyear2020 {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/act-notice/new-year-2020/HD_tc_bg.png)
        no-repeat;
      background-size: cover;
      font-size: 0.12rem;
      -webkit-animation-duration: 0.3s;
      animation-duration: 0.3s;
      position: relative;
      .title-bg {
        background: url(~@/assets/img/act-notice/new-year-2020/HD_bt_zi_en.png)
          no-repeat;
        background-size: cover;
        top: 0.17rem;
      }
      .tag-list {
        .tag-item {
          width: 1.39rem;
          &.tag-item-act {
            background: url(~@/assets/img/act-notice/new-year-2020/HD_title_zyq_1.png)
              no-repeat;
            background-size: cover;
            margin-right: -0.04rem;
            &.selected {
              background: url(~@/assets/img/act-notice/new-year-2020/HD_title_zyq_2.png)
                no-repeat;
              background-size: cover;
              line-height: 0.3rem;
            }
          }
          &.tag-item-notice {
            background: url(~@/assets/img/act-notice/new-year-2020/HD_title_yyq_1.png)
              no-repeat;
            background-size: cover;
            &.selected {
              background: url(~@/assets/img/act-notice/new-year-2020/HD_title_yyq_2.png)
                no-repeat;
              background-size: cover;
              line-height: 0.3rem;
            }
          }
        }
      }
      .content-wrapper {
        .content {
          color: red;
        }
      }
    }
    .new-year-img-1 {
      width: 1.38rem;
      height: 0.895rem;
      position: absolute;
      left: -0.15rem;
      top: -0.35rem;
    }
    .new-year-img-2 {
      width: 0.44rem;
      height: 0.855rem;
      position: absolute;
      left: -0.19rem;
      top: 0.35rem;
      z-index: 1;
    }
    .new-year-img-3 {
      width: 0.44rem;
      height: 0.855rem;
      position: absolute;
      right: -0.08rem;
      top: 0.35rem;
      z-index: 1;
    }
    .new-year-img-4 {
      width: 0.52rem;
      height: 0.27rem;
      position: absolute;
      top: 0.125rem;
      left: 1.1rem;
    }
    .new-year-img-5 {
      width: 0.52rem;
      height: 0.27rem;
      position: absolute;
      top: 0.125rem;
      right: 0.11rem;
    }
    .title-bg {
      width: 0.99rem;
      height: 0.21rem;
      background: url(~@/assets/img/act-notice/HD_bt_zi_en.png) no-repeat;
      background-size: cover;
      position: absolute;
      left: 0.23rem;
      top: 0.15rem;
    }
    .title-bg2 {
      width: 5.17rem;
      height: 0.69rem;
      position: absolute;
      left: -0.2rem;
      top: -0.48rem;
    }
    .deng-img {
      width: 1.315rem;
      height: 1.37rem;
      position: absolute;
      left: -0.8rem;
      top: -0.4rem;
    }
    .img-2020 {
      width: 1.135rem;
      height: 0.81rem;
      position: absolute;
      right: -0.8rem;
      bottom: -0.4rem;
    }
    .content-bg {
      width: 4.42rem;
      height: 2.02rem;
      position: absolute;
      left: 50%;
      bottom: 0.18rem;
      transform: translateX(-50%);
    }
    .tag-list {
      position: absolute;
      top: 0.1rem;
      left: 1.5rem;
      .tag-item {
        width: 1.37rem;
        height: 0.325rem;
        display: block;
        float: left;
        font-size: 0.12rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.28rem;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &.tag-item-act {
          background: url(~@/assets/img/act-notice/HD_title_zyq_1.png) no-repeat;
          background-size: cover;
          &.selected {
            background: url(~@/assets/img/act-notice/HD_title_zyq_2.png)
              no-repeat;
            background-size: cover;
            line-height: 0.3rem;
          }
        }
        &.tag-item-notice {
          background: url(~@/assets/img/act-notice/HD_title_yyq_1.png) no-repeat;
          background-size: cover;
          &.selected {
            background: url(~@/assets/img/act-notice/HD_title_yyq_2.png)
              no-repeat;
            background-size: cover;
            line-height: 0.3rem;
          }
        }
      }
    }
    .ani-dialog-notice-box-newyear2020 {
      .tag-menu-box {
        width: 0.95rem;
        height: 1.965rem;
        background: url(~@/assets/img/act-notice/new-year-2020/di2.png)
          no-repeat;
        background-size: cover;
        .tag-menu-list {
          .tag-menu-item {
            width: 100%;
            height: 0.445rem;
            display: block;
            color: #709fcb;
            text-align: center;
            background: url(~@/assets/img/act-notice/new-year-2020/HD_gg_yq_2.png)
              no-repeat;
            background-size: cover;
            .item-content {
              // background: url(~@/assets/img/act-notice/HD_hd_logo_2.png) 0.075rem
              //   0.1525rem no-repeat;
              // background-size: 0.16rem 0.16rem;
              width: 98%;
              word-wrap: break-word;
              white-space: pre-wrap;
              display: inline-block;
              vertical-align: middle;
            }
            .innerDiv-fix {
              display: inline-block;
              width: 0;
              height: 100%;
              line-height: 100%;
              vertical-align: middle;
              visibility: hidden;
            }
            &.notice {
              .item-content {
                // background: url(~@/assets/img/act-notice/new-year-2020/HD_gg_logo_2.png)
                //   0.075rem 0.142rem no-repeat;
                // background-size: 0.16rem 0.16rem;
              }
              &.selected {
                .item-content {
                  // background: url(~@/assets/img/act-notice/new-year-2020/HD_gg_logo_1.png)
                  //   0.075rem 0.142rem no-repeat;
                  // background-size: 0.16rem 0.16rem;
                  color: #ffffff;
                }
              }
            }
            &.selected {
              background: url(~@/assets/img/act-notice/new-year-2020/HD_gg_yq_1.png)
                no-repeat;
              background-size: contain;
              .item-content {
                // background: url(~@/assets/img/act-notice/new-year-2020/HD_hd_logo_1.png)
                //   0.075rem 0.142rem no-repeat;
                // background-size: 0.16rem 0.16rem;
                color: #ffffff;
              }
            }
          }
        }
      }
    }
    .tag-menu-box {
      position: absolute;
      left: 0.21rem;
      top: 0.52rem;
      width: 0.93rem;
      height: 1.95rem;
      overflow: hidden;
      .tag-menu-list {
        .tag-menu-item {
          width: 100%;
          height: 0.445rem;
          display: block;
          color: #709fcb;
          text-align: center;
          background: url(~@/assets/img/act-notice/HD_gg_yq_2.png) no-repeat;
          background-size: cover;
          .item-content {
            // background: url(~@/assets/img/act-notice/HD_hd_logo_2.png) 0.075rem
            //   0.1525rem no-repeat;
            // background-size: 0.16rem 0.16rem;
            word-wrap: break-word;
            white-space: pre-wrap;
            display: inline-block;
            vertical-align: middle;
          }
          .innerDiv-fix {
            display: inline-block;
            width: 0;
            height: 100%;
            line-height: 100%;
            vertical-align: middle;
            visibility: hidden;
          }
          &.notice {
            // .item-content {
            //   background: url(~@/assets/img/act-notice/HD_gg_logo_2.png)
            //     0.075rem 0.1525rem no-repeat;
            //   background-size: 0.16rem 0.16rem;
            //}
            &.selected {
              .item-content {
                // background: url(~@/assets/img/act-notice/HD_gg_logo_1.png)
                //   0.075rem 0.1525rem no-repeat;
                // background-size: 0.16rem 0.16rem;
                color: #ffffff;
              }
            }
          }
          &.selected {
            background: url(~@/assets/img/act-notice/HD_gg_yq_1.png) no-repeat;
            background-size: cover;
            .item-content {
              // background: url(~@/assets/img/act-notice/HD_hd_logo_1.png)
              //   0.075rem 0.1525rem no-repeat;
              // background-size: 0.16rem 0.16rem;
              color: #ffffff;
            }
          }
        }
      }
    }
    .content-wrapper {
      width: 3.305rem;
      height: 1.885rem;
      position: absolute;
      overflow: hidden;
      display: block;
      left: 1.21rem;
      top: 0.53rem;
      .content {
        font-size: 0.1rem;
        color: #ffffff;
        width: 100%;
        word-wrap: break-word;
        word-break: break-all;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .close-pop-message {
      position: absolute;
      right: -0.09rem;
      top: -0.09rem;
    }
    .close-pop-message-new-year-2020 {
      top: -0.23rem;
      height: 0.42rem;
      width: 0.42rem;
      background: url(~@/assets/img/act-notice/new-year-2020/x.png) no-repeat;
      background-size: cover;
    }
  }
}

@media all and (orientation: portrait) {
  .dialog-notice-box {
    transform: translate(-50%, -50%) rotate(90deg) !important;
    -webkit-transform: translate(-50%, -50%) rotate(90deg) !important;
    -moz-transform: translate(-50%, -50%) rotate(90deg) !important;
    -ms-transform: translate(-50%, -50%) rotate(90deg) !important;
    -o-transform: translate(-50%, -50%) rotate(90deg) !important;
  }
}
</style>